/**
 * Reescreve `level` das linhas da DRE de grupo pela profundidade real da árvore.
 *
 * No grupo, a conta consolidada e a conta da empresa-membro chegam com o MESMO `level` — as duas
 * são "0", porque a série da empresa é a mesma conta do template. Como a indentação da tela sai de
 * `level` (diretivas `margin-level` e `padding-level`), a empresa aparecia alinhada com o
 * consolidado, e o analítico dela alinhado com a empresa: a hierarquia não se lia, embora a
 * árvore em si estivesse correta.
 *
 * `FinancialDreService.seriesAndIndicatorsGroup` já monta `father` a partir do `compound`, então
 * a profundidade já está disponível — basta reescrever `level` com ela.
 *
 * Só mexe em quem já tem `level`: os indicadores (Receita Líquida, margens) vêm sem o campo de
 * propósito, e é assim que `showExpandable` e `_setInitialOpeneds` os tratam como não expansíveis
 * e sempre visíveis.
 *
 * Muta a lista recebida, que é o que os dois chamadores esperam.
 */
export function setDreLevelsByDepth(list = []) {
    const byId = new Map(list.map((serie) => [serie._id, serie]));
    const depthById = new Map();

    const depthOf = (serie, seen) => {
        if (depthById.has(serie._id)) return depthById.get(serie._id);
        // Um `compound` cíclico travaria a tela; sem a guarda a recursão não termina.
        if (seen.has(serie._id)) return 0;
        seen.add(serie._id);

        const father = serie.father ? byId.get(serie.father) : undefined;
        const depth = father ? depthOf(father, seen) + 1 : 0;
        depthById.set(serie._id, depth);
        return depth;
    };

    list.forEach((serie) => {
        if (typeof serie.level === "undefined") return;
        serie.level = String(depthOf(serie, new Set()));
    });

    return list;
}
